import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    rallies: [],
    ralliesStatus: 'idle',
    ralliesThemes: [],
    ralliesTargetGroups: [],
    selectedThemeId: null,
    selectedTargetGroupId: null,
    locationFilter: null,
    isTeamRally: undefined,
};
const ralliesPreviewSlice = createSlice({
    name: 'ralliesPreview',
    initialState,
    reducers: {
        setRallies: (state, action) => {
            state.rallies = action.payload;
            state.ralliesStatus = 'loaded';
        },
        // keeps the previous rallies so the map does not jump while the list shows the loader
        setRalliesLoading: (state) => {
            state.ralliesStatus = 'loading';
        },
        setRalliesLoadFailed: (state) => {
            state.rallies = [];
            state.ralliesStatus = 'error';
        },
        setRalliesThemes: (state, action) => {
            state.ralliesThemes = action.payload;
        },
        setRalliesTargetGroups: (state, action) => {
            state.ralliesTargetGroups = action.payload;
        },
        setTheme: (state, action) => {
            state.selectedThemeId = action.payload;
        },
        setTargetGroup: (state, action) => {
            state.selectedTargetGroupId = action.payload;
        },
        setLocationFilter: (state, action) => {
            state.locationFilter = action.payload;
        },
        setIsTeamRally: (state, action) => {
            state.isTeamRally = action.payload;
        },
    },
    selectors: {
        selectRallies: (state) => state.rallies,
        selectRalliesStatus: (state) => state.ralliesStatus,
        selectRalliesThemes: (state) => state.ralliesThemes,
        selectRalliesTargetGroup: (state) => state.ralliesTargetGroups,
        getSelectThemeId: (state) => state.selectedThemeId,
        getSelectTargetGroupId: (state) => state.selectedTargetGroupId,
        getLocationFilter: (state) => state.locationFilter,
        getIsTeamRally: (state) => state.isTeamRally,
    },
});
export const { setRallies, setRalliesLoading, setRalliesLoadFailed, setRalliesThemes, setRalliesTargetGroups, setTheme, setLocationFilter, setTargetGroup, setIsTeamRally, } = ralliesPreviewSlice.actions;
export const { selectRallies, selectRalliesStatus, selectRalliesThemes, selectRalliesTargetGroup, getSelectThemeId, getSelectTargetGroupId, getLocationFilter, getIsTeamRally, } = ralliesPreviewSlice.selectors;
export default ralliesPreviewSlice.reducer;
